import React, { useState } from 'react';
import { Button, Form, Modal, message } from 'antd';
import api from '../../../authentication/axiosInstance';
import EquipmentDetailsFields from './EquipmentDetailsFields';
import { formatApiError } from './DdPlowFormModal';

// Empty inputs are left out so the model defaults apply (coverage rates 0, staff limit 1).
export const buildEquipmentPayload = (values) => Object.entries(values).reduce((payload, [name, value]) => {
  const normalized = typeof value === 'string' ? value.trim() : value;
  if (normalized !== undefined && normalized !== null && normalized !== '') {
    payload[name] = normalized;
  }
  return payload;
}, {});

const INITIAL_VALUES = { equipment_status_name: 'In-Service', walks_coverage_rate: 0, lots_coverage_rate: 0, staff_limit: 1 };

// Mounted fresh for every open so a new equipment form never shows values typed earlier.
const EquipmentCreateForm = ({ onCreated }) => {
  const [form] = Form.useForm();
  const [saving, setSaving] = useState(false);

  const handleFinish = async (values) => {
    setSaving(true);
    try {
      await api.post('/equipment/', buildEquipmentPayload(values));
      message.success('Equipment created successfully');
      onCreated();
    } catch (error) {
      console.error('Failed to create equipment:', error);
      const data = error.response?.data;
      if (data && typeof data === 'object') {
        form.setFields(Object.entries(data)
          .filter(([name]) => name in values)
          .map(([name, errors]) => ({ name, errors: [].concat(errors) })));
      }
      const detail = formatApiError(data);
      message.error(`Failed to create equipment${detail ? `: ${detail}` : ''}`);
    } finally {
      setSaving(false);
    }
  };

  return (
    <Form
      form={form}
      initialValues={INITIAL_VALUES}
      onFinish={handleFinish}
      layout="vertical"
    >
      <EquipmentDetailsFields />
      <Form.Item style={{ marginTop: '24px' }}>
        <Button type="primary" htmlType="submit" size="large" block loading={saving}>
          Create Equipment
        </Button>
      </Form.Item>
    </Form>
  );
};

const EquipmentCreateModal = ({ open, onClose, onCreated }) => (
  <Modal
    title="Add Equipment"
    open={open}
    onCancel={onClose}
    footer={null}
    width={800}
    styles={{ body: { maxHeight: '70vh', overflowY: 'auto' } }}
    destroyOnClose
  >
    {open && <EquipmentCreateForm onCreated={onCreated} />}
  </Modal>
);

export default EquipmentCreateModal;
